import React from 'react';
import { Box } from '@material-ui/core';

import { Handle, Position } from 'react-flow-renderer';
import { NODE_WIDTH, NODE_HEIGHT } from '../flowProcess';


// All nodes have a fixed width and height to support layouting.
const Node = ({
  children
}: any) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    width={NODE_WIDTH}
    height={NODE_HEIGHT}
    style={{ cursor: 'auto' }}
  >
    <Handle style={{ opacity: 0 }} type="target" position={Position.Top} />
    {children}
    <Handle style={{ opacity: 0 }} type="source" position={Position.Bottom} />
  </Box>
);

export default Node;
